import React from "react";
import { Global, css } from "@emotion/react";

const GlobalStyles = () => (
  <Global
    styles={css`
      body {
        margin: 0;
        width: 100vw;
        overflow-x: hidden;
        overscroll-behavior: none;
        &.no-scroll {
          overflow: hidden;
        }
        ::-webkit-scrollbar {
          display: none;
        }
      }

      #hs-app {
        [class^="interactiveStory_"] {
          padding-bottom: 0;
        }
      }

      html {
        height: 100%;
        width: 100%;
        overscroll-behavior: none;
      }

      nav[data-cy="horizontalMenu"] {
        display: none !important;
      }

      [footer] {
        display: none !important;
      }

      #___gatsby {
        margin: 0;
        font-size: 18px;
        font-family: "univers-light", sans-serif;
        line-height: 1.4em;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: rgba(33, 23, 3, 1);
        box-sizing: border-box;
        margin: 0;
      }

      a,
      a:visited {
        color: black;
        text-decoration: none;
      }

      button {
        padding: 0px;

        &:hover,
        &:focus {
          outline: none;
        }
      }

      img {
        max-width: 100%;
      }
    `}
  />
);

export default GlobalStyles;
